import * as React from 'react';

import { store } from 'src/stores';
import { landingActions } from '../reducers';

export const handleChangeNavigation = (tab: { key: React.Key }) => {
  store.dispatch(landingActions.changeSelectedItem(tab.key.toString()))
};
